import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { City, State } from 'src/models';
import { EnumBrazilState } from 'src/models/enums';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyService extends RestApiService {
  //Variáveis
  private _urlStates = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
  private _urlCities = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/:UF/distritos';

  constructor(public http: HttpClient) {
    super(http);
  }

  getStates() {
    const url = this._urlStates;
    return this.get(url, State) as Observable<State[]>;
  }

  getCities(state: EnumBrazilState) {
    const url = this._urlCities.replace(':UF', state);
    return this.get(url, City) as Observable<City[]>;
  }

  createActiveCampaign(url: string) {
    return this.get(url, City) as Observable<City>;
  }

}
